import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireReviewDynamicStyleType,
    QuestionnaireReviewRowConstantType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const getQuestionnaireReviewRowStyle = ({
    borders,
    isFirst,
    colors,
    isLast,
    spaces
}: QuestionnaireReviewRowConstantType): ViewStyle => {
    const style: Mutable<ViewStyle> = {
        borderBottomColor: colors.content.border.subtle,
        borderBottomWidth: borders.separator,
        paddingVertical: spaces.spacingSm,
        gap: spaces.spacingMd
    };

    if(isFirst) {
        style.paddingTop = 0;
    }

    if(isLast) {
        style.paddingBottom = 0;

        style.borderBottomWidth = 0;
    }

    return style;
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    list: {
        flexDirection: "column",
        minWidth: 0
    },
    text: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    }
});

export const useStyles = ({
    controlHeights,
    iconSizes,
    spaces
}: QuestionnaireReviewDynamicStyleType) => {
    const styles = {
        action: {
            marginEnd: (iconSizes.small - controlHeights.small) / 2
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
